import { useEffect } from "react";
import { useStore } from "../store/StoreProvider";
import { useAPIQuery } from "../api/useAPIQuery";
import { useAPI } from "../api/useAPI";

export const useGetAccounts = () => {
  const api = useAPI();
  const { state, setState } = useStore();
  const { data, query } = useAPIQuery({
    apiCall: api.accountGet,
  });
  useEffect(() => {
    if (data && data.accounts.length > 0) {
      setState((s) => ({
        ...s,
        accounts: data.accounts,
      }));
    }
  }, [data, setState]);

  useEffect(() => {
    if (state.accounts.length === 0) {
      query({});
    }
  }, [query, state.accounts.length]);
  return state.accounts;
};
